import React, { Fragment, useContext, useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  Paper,
  Checkbox,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 447,
  },
  // button: { textTransform: "none", "&:focus": { outline: "none" } },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  header2: {
    zIndex: theme.zIndex.mobileStepper,
  },
  cell: {
    minWidth: 120,
    borderRight: "1px solid lightgrey",
  },
  cell_none: {
    border: "none",
    height: 45,
  },
  cell_note: {
    fontSize: 11,
    color: "grey",
  },
  body: {
    marginBottom: 50,
  },
  footer: {
    bottom: 0,
    zIndex: theme.zIndex.mobileStepper,
    fontWeight: "bold",
    borderTop: "1px solid lightgrey",
  },
  fixedCheckbox_header: {
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.speedDial,
  },
  fixedCell_header: {
    left: 49,
    position: "sticky",
    zIndex: theme.zIndex.speedDial,
    borderRight: "2px solid lightgrey",
  },
  fixedCheckbox_body: {
    left: 0,
    position: "sticky",
    backgroundColor: "#fff",
  },
  fixedCell_body: {
    left: 49,
    position: "sticky",
    backgroundColor: "#fff",
    borderRight: "2px solid lightgrey",
  },
}));

const DashboardStats_03 = () => {
  const classes = useStyles();

  const {
    adset_stats,
    selected_fb_details,
    selected_profile,
    adset_selected,
    setAdsetSelected,
    stats_name_filter,
    adset_filtered,
  } = useContext(FacebookProfilesDashboardContext);

  // TABLE
  const createHead = (id, label, align, disablePadding) => {
    return {
      id,
      label,
      align,
      disablePadding,
    };
  };

  const heads = [
    createHead("name", "Ad Set Name", "left", true),
    createHead("delivery", "Delivery", "left", false),
    createHead("spend", "Amount Spend", "left", false),
    createHead("daily_budget", "Budget", "left", false),
    createHead("results", "Results", "left", false),
    createHead("cost_per_result", "Cost Per Result", "left", false),
    createHead("purchase_roas", "Purchase ROAS", "left", false),
    createHead("purchase_roas_value", "Purchase ROAS Value", "left", false),
    createHead("cpc", "CPC", "left", false),
    createHead("ctr", "CTR", "left", false),
    createHead("video_view", "Video Average Watch Time", "left", false),
  ];

  const summary_template = {
    adset: 0,
    spend: "",
    daily_budget: 0.0,
    results: "",
    cost_per_result: "",
    purchase_roas: "",
    purchase_roas_value: "",
    cpc: "",
    ctr: "",
    video_view: "",
  };

  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(summary_template);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [title_01, setTitle01] = useState("");

  const onSelectAllClick = (e) => {
    if (e.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setAdsetSelected(newSelecteds);
      return;
    }

    setAdsetSelected([]);
  };

  const onClick = (e, name) => {
    const selectedIndex = adset_selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(adset_selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(adset_selected.slice(1));
    } else if (selectedIndex === adset_selected.length - 1) {
      newSelected = newSelected.concat(adset_selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        adset_selected.slice(0, selectedIndex),
        adset_selected.slice(selectedIndex + 1)
      );
    }

    setAdsetSelected(newSelected);
  };

  const onRequestSort = (e, prop) => {
    const isAsc = orderBy === prop && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(prop);
  };

  const createSortHandler = (property) => (e) => {
    onRequestSort(e, property);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  };

  const textTransform = (text) => {
    return text.toUpperCase().replace(/\_/g, " ");
  };

  useEffect(() => {
    //  Stats Subtitle
    if (selected_profile.adset) {
      let optimization_goal = "";

      for (let x in selected_profile.adset) {
        if (selected_profile.adset[x].optimization_goal) {
          // Convert To Pascal Case
          optimization_goal = selected_profile.adset[x].optimization_goal;
          optimization_goal = optimization_goal.replace("_", " ");
          optimization_goal = optimization_goal.replace(/\w+/g, function (w) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase();
          });
        }
      }

      setTitle01(optimization_goal);
    }

    let delivery = "";

    selected_profile.ad_account.map((each) => {
      if (each.ad_account_id === selected_fb_details.ad_account) {
        if (each.ad_account_status === 2) delivery = "DISABLED";
      }
    });

    let adset = 0;
    let spend = 0.0;
    let daily_budget = 0.0;
    let results = 0;
    let cost_per_result = 0.0;
    // let purchase_roas = 0.0;
    let purchase_roas_value = 0.0;
    let cpc = 0.0;
    let ctr = 0.0;
    let video_view = 0.0;

    let rows = [];
    let summary = summary_template;

    if (stats_name_filter["Ad Set"] !== "") {
      adset_filtered.map((each) => {
        adset += 1;
        spend += parseFloat(each.spend);
        daily_budget += parseFloat(each.daily_budget);
        results += parseInt(each.results);
        cost_per_result += parseFloat(each.cost_per_result);
        // purchase_roas += parseFloat(each.purchase_roas);
        purchase_roas_value += parseFloat(each.purchase_roas_value);
        cpc += parseFloat(each.cpc);
        ctr += parseFloat(each.ctr);
        video_view += parseFloat(each.video_view);

        if (delivery === "DISABLED") each.delivery = delivery;

        rows.push(each);
      });
    } else {
      adset_stats.map((each) => {
        adset += 1;
        spend += parseFloat(each.spend);
        daily_budget += parseFloat(each.daily_budget);
        results += parseInt(each.results);
        cost_per_result += parseFloat(each.cost_per_result);
        // purchase_roas += parseFloat(each.purchase_roas);
        purchase_roas_value += parseFloat(each.purchase_roas_value);
        cpc += parseFloat(each.cpc);
        ctr += parseFloat(each.ctr);
        video_view += parseFloat(each.video_view);

        if (delivery === "DISABLED") each.delivery = delivery;

        rows.push(each);
      });
    }

    if (rows.length > 0) {
      summary = {
        adset,
        spend: spend.toFixed(2),
        daily_budget: daily_budget.toFixed(2),
        results,
        cost_per_result: cost_per_result.toFixed(2),
        // purchase_roas: purchase_roas.toFixed(2),
        purchase_roas: (purchase_roas_value / spend || 0).toFixed(2),
        purchase_roas_value: purchase_roas_value.toFixed(2),
        cpc: cpc.toFixed(2),
        ctr: ctr.toFixed(2),
        video_view: video_view.toFixed(2),
      };
    }

    while (rows.length < 7) rows.push({});

    setRows(rows);
    setSummary(summary);
  }, [selected_fb_details, adset_stats, adset_filtered]);

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table size="small" stickyHeader className={classes.root}>
        <TableHead>
          <TableRow>
            <TableCell
              padding="checkbox"
              className={clsx(classes.header2, {
                [classes.fixedCheckbox_header]: true,
              })}
            >
              <Checkbox
                indeterminate={
                  adset_selected.length > 0 &&
                  adset_selected.length < rows.length
                }
                checked={
                  rows.length > 0 && adset_selected.length === rows.length
                }
                onChange={onSelectAllClick}
              />{" "}
            </TableCell>
            {heads.map((head, index) => (
              <TableCell
                key={index}
                align={head.align}
                padding={head.disablePadding ? "none" : "default"}
                sortDirection={orderBy === head.id ? order : false}
                className={clsx(classes.header2, {
                  [classes.fixedCell_header]: index === 0,
                  [classes.cell]: index !== 0,
                })}
              >
                <TableSortLabel
                  active={orderBy === head.id}
                  direction={orderBy === head.id ? order : "asc"}
                  onClick={createSortHandler(head.id)}
                >
                  {head.label}{" "}
                  {orderBy === head.id ? (
                    <span className={classes.visuallyHidden}>
                      {" "}
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}{" "}
                    </span>
                  ) : null}{" "}
                </TableSortLabel>{" "}
              </TableCell>
            ))}{" "}
          </TableRow>{" "}
        </TableHead>
        <TableBody className={classes.body}>
          {" "}
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            const isItemSelected = adset_selected.indexOf(row.id) !== -1;

            return Object.keys(row).length > 0 ? (
              <TableRow
                key={index}
                hover
                role="checkbox"
                tabIndex={-1}
                selected={isItemSelected}
                onClick={(e) => onClick(e, row.id)}
              >
                <TableCell
                  padding="checkbox"
                  className={classes.fixedCheckbox_body}
                >
                  <Checkbox checked={isItemSelected} />{" "}
                </TableCell>{" "}
                <TableCell
                  align="left"
                  padding="none"
                  className={clsx(classes.cell, {
                    [classes.fixedCell_body]: true,
                  })}
                >
                  {row.name}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {textTransform(row.delivery)}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  $ {row.spend}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  $ {row.daily_budget}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  <Fragment>
                    {" "}
                    {row.results ? row.results : "-"} <br />
                    <span className={classes.cell_note}> {title_01} </span>{" "}
                  </Fragment>{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  <Fragment>
                    {" "}
                    {row.cost_per_result ? `$${row.cost_per_result}` : "-"}{" "}
                    <br />
                    <span className={classes.cell_note}>
                      {" "}
                      Per {title_01}{" "}
                    </span>{" "}
                  </Fragment>{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.purchase_roas ? row.purchase_roas : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.purchase_roas_value ? row.purchase_roas_value : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.cpc ? row.cpc : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.ctr ? row.ctr : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.video_view}{" "}
                </TableCell>{" "}
              </TableRow>
            ) : (
              <TableRow key={index}>
                <TableCell
                  colSpan={10}
                  className={classes.cell_none}
                ></TableCell>{" "}
              </TableRow>
            );
          })}{" "}
        </TableBody>
        <TableHead>
          <TableRow>
            <TableCell
              padding="checkbox"
              className={clsx(classes.footer, {
                [classes.fixedCheckbox_header]: true,
              })}
            ></TableCell>{" "}
            <TableCell
              align="left"
              className={clsx(classes.footer, {
                [classes.fixedCell_header]: true,
              })}
            >
              Results from {summary.adset}
              ad sets{" "}
            </TableCell>{" "}
            <TableCell className={classes.footer}> </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.spend} <br />
              <span className={classes.cell_note}> Total Spent </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.daily_budget} <br />
              <span className={classes.cell_note}> Total Budget </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.results} <br />
              <span className={classes.cell_note}> {title_01} </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.cost_per_result} <br />
              <span className={classes.cell_note}> Per {title_01} </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.purchase_roas} <br />
              <span className={classes.cell_note}> Average </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.purchase_roas_value} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.cpc} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.ctr} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.video_view} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
          </TableRow>{" "}
        </TableHead>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default DashboardStats_03;
